import {
  LegalPageLayout,
  LegalSection,
  LegalParagraph,
  LegalBulletList,
} from './LegalPage'

export function PrivacyPolicyPage() {
  return (
    <LegalPageLayout title="Lightstrike App Privacy Policy">
      <LegalSection heading="Introduction">
        <LegalParagraph>
          This privacy policy outlines the commitment of Lightstrike LLC
          (referred to as &quot;we&quot;, &quot;us&quot;, or &quot;our&quot;),
          who own and operate the Lightstrike app, to protect the privacy of
          our users (&quot;you&quot; or &quot;your&quot;). This policy sets
          forth how we collect, use, disclose, and safeguard the information
          you provide while using the Lightstrike app.
        </LegalParagraph>
      </LegalSection>

      <LegalSection heading="Information Collection">
        <LegalBulletList
          items={[
            'Personal Information: We collect personal information you provide, such as name, email address, and payment information, for account creation and billing purposes.',
            'Usage Data: We collect information on how you interact with the app, including features used, time spent, and in-app preferences.',
            'Device Information: Information about your device, such as model, operating system, and unique device identifiers, is collected for analytics and service improvement purposes.',
            'Location Data: With your permission, we collect location data for providing location-based services.',
          ]}
        />
      </LegalSection>

      <LegalSection heading="Use of Information">
        <LegalParagraph>Your information is used to:</LegalParagraph>
        <LegalBulletList
          items={[
            "Provide, maintain, and improve the app's functionalities.",
            'Communicate with you, including updates and customer support.',
            'Process transactions and manage your account.',
            'Implement security measures and protect your data.',
          ]}
        />
      </LegalSection>

      <LegalSection heading="Data Sharing and Disclosure">
        <LegalParagraph>
          We do not sell your personal data to third parties. Information may
          be shared with:
        </LegalParagraph>
        <LegalBulletList
          items={[
            'Service providers who assist in our operations (e.g., cloud hosting, payment processing).',
            'Law enforcement, if required by law or to protect your safety and the safety of others.',
          ]}
        />
      </LegalSection>

      <LegalSection heading="Data Security">
        <LegalParagraph>
          We prioritize the security of your data. We implement the strongest
          security standards and practices, including:
        </LegalParagraph>
        <LegalBulletList
          items={[
            'Encryption of data in transit and at rest.',
            'Regular security audits and updates.',
            'Restricted access to your data by authorized personnel only.',
          ]}
        />
      </LegalSection>

      <LegalSection heading="Data Retention">
        <LegalParagraph>
          We retain your information only as long as necessary for the purposes
          outlined in this policy or as required by law.
        </LegalParagraph>
      </LegalSection>

      <LegalSection heading="Your Rights">
        <LegalParagraph>You have the right to:</LegalParagraph>
        <LegalBulletList
          items={[
            'Access the personal information we hold about you.',
            'Request correction or deletion of your information.',
            'Withdraw consent for data processing, where applicable.',
          ]}
        />
      </LegalSection>

      <LegalSection heading="Changes to the Privacy Policy">
        <LegalParagraph>
          We may update this policy from time to time. We will notify you of
          any significant changes and post the updated policy on our website.
        </LegalParagraph>
      </LegalSection>

      <LegalSection heading="Contact Us">
        <LegalParagraph>
          For questions or concerns regarding this privacy policy, please
          contact us at hello@lightstrikelabs.com.
        </LegalParagraph>
      </LegalSection>

      <LegalParagraph>
        By using the Lightstrike app, you acknowledge that you have read and
        understood this Privacy Policy.
      </LegalParagraph>
    </LegalPageLayout>
  )
}
